import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/services/api';

type DeleteTagPayload = {
  tagId: string | number;
};

export const useDeleteTag = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['deleteTag'],
    mutationFn: ({ tagId }: DeleteTagPayload) => api.delete(`/v3/tag/${tagId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tagList'] });
    },
  });
};
